/* LULAB Clarity/Sentry correlation bridge.
 * Reviewed against Clarity 0.8.69 and Sentry 8.55.2.
 * Load before the Sentry loader; replace the old correlation bootstrap.
 */
(function (w) {
  'use strict';
  if (w.lulabObservability && w.lulabObservability.integration) return;

  var projectId = 'x1bvc5u6ql';
  var storageKey = 'lulab_observability_correlation_id';
  var correlationId = w.lulabObservability && w.lulabObservability.correlationId;
  try { correlationId = correlationId || w.sessionStorage.getItem(storageKey); } catch (_) {}
  if (!correlationId) {
    correlationId = w.crypto && w.crypto.randomUUID
      ? w.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    try { w.sessionStorage.setItem(storageKey, correlationId); } catch (_) {}
  }

  w.clarity = w.clarity || function () {
    (w.clarity.q = w.clarity.q || []).push(arguments);
  };

  // At most one outstanding diagnostic read, even if a future SDK stops
  // invoking the metadata callback synchronously. Never retain an event here.
  var readPending = false;
  var observedErrors = new WeakMap();

  function identifySession() {
    try {
      // Resolve the global each time: Clarity replaces it on start/stop.
      w.clarity('identify', correlationId, correlationId);
      w.clarity('set', 'clarity_custom_session_id', correlationId);
    } catch (_) { /* Clarity failure must not interrupt the storefront. */ }
  }

  function consentValue(value) {
    return value === 'granted' || value === 'denied' ? value : 'unknown';
  }

  function snapshot() {
    var out = {
      custom_session_id: correlationId,
      reference_status: 'sdk_not_ready',
      playback_status: 'unverified',
      captured_at: new Date().toISOString()
    };
    var clarity = w.clarity;
    // Clarity 0.8.69's running dispatcher has .v; its inactive queue does not.
    // This avoids queuing one metadata command for every error while blocked.
    if (typeof clarity !== 'function' || typeof clarity.v !== 'string') return out;
    out.sdk_version = clarity.v;
    out.reference_status = 'metadata_unavailable';
    if (readPending) return out;

    var accepting = true;
    readPending = true;
    try {
      clarity('metadata', function (metadata, recordingEnabled, consent) {
        readPending = false;
        // A late response belongs to a later moment, not this error.
        if (!accepting) return;
        if (!metadata || !metadata.projectId || !metadata.userId || !metadata.sessionId) return;
        if (String(metadata.projectId) !== projectId) {
          out.reference_status = 'project_mismatch';
          return;
        }
        out.project_id = String(metadata.projectId);
        out.user_id = String(metadata.userId);
        out.session_id = String(metadata.sessionId);
        out.page_number = metadata.pageNum;
        out.analytics_storage = consentValue(consent && consent.analytics_Storage);
        out.ad_storage = consentValue(consent && consent.ad_Storage);
        out.recording_enabled = recordingEnabled === true;
        out.reference_status = recordingEnabled === true ? 'captured' : 'recording_not_enabled';
        if (recordingEnabled === true) {
          out.session_url = 'https://clarity.microsoft.com/player/' +
            [out.project_id, out.user_id, out.session_id].map(encodeURIComponent).join('/');
        }
      }, false, false, true);
    } catch (_) {
      readPending = false;
      out.reference_status = 'sdk_error';
    } finally {
      accepting = false;
    }
    return out;
  }

  function isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
  }

  // Preserve the reference at the browser error/rejection, including errors
  // the Sentry loader buffers before its full SDK starts. No event is emitted.
  function remember(value) {
    if (isObject(value)) observedErrors.set(value, snapshot());
  }
  w.addEventListener('error', function (event) { remember(event.error); }, true);
  w.addEventListener('unhandledrejection', function (event) { remember(event.reason); }, true);

  function annotate(event, hint) {
    if (event.type) return; // This bridge covers errors/messages, not transactions.
    var original = hint && hint.originalException;
    var explicit = hint && hint.captureContext && hint.captureContext.contexts;
    var reference = explicit && explicit.clarity;
    if (!reference || reference.custom_session_id !== correlationId) {
      reference = isObject(original) && observedErrors.get(original);
    }
    if (isObject(original)) observedErrors.delete(original);
    reference = reference || snapshot();
    event.tags = Object.assign({}, event.tags, {
      clarity_custom_session_id: correlationId,
      clarity_reference_status: reference.reference_status,
      clarity_playback_status: reference.playback_status,
      clarity_project_id: reference.project_id,
      clarity_user_id: reference.user_id,
      clarity_session_id: reference.session_id,
      clarity_session_url: reference.session_url
    });
    // Fresh scalar-only object: later SDK restarts cannot mutate this event.
    event.contexts = Object.assign({}, event.contexts, { clarity: reference });
  }

  w.lulabObservability = {
    correlationId: correlationId,
    // Use for handled errors that may be buffered by the Sentry loader:
    // Sentry.captureException(error, lulabObservability.captureContext()).
    captureContext: function () { return { contexts: { clarity: snapshot() } }; },
    integration: function () {
      return {
        name: 'LulabClarityCorrelation',
        setup: function (client) {
          client.on('preprocessEvent', function (event, hint) {
            try { annotate(event, hint); } catch (_) {
              // Always let Sentry continue if the optional bridge fails.
            }
          });
        }
      };
    }
  };

  try {
    // This observer only reapplies our custom ID; it does not cache native IDs.
    w.clarity('metadata', identifySession, false, true);
    identifySession();
  } catch (_) {}
})(window);
